// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__uhPh2","secondary":"Button_secondary__H+cIF"};